import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ai-credits")({
  component: lazyRouteComponent(() => import("./-pages/admin.ai-credits")),
  head: () => ({
    meta: [
      { title: "رصيد AI · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
